
import { ProjectStatus, ERPModule, Country, BitumenGrade, Company, OrderStatus, PaymentStatus } from "./types";
import type { Project, User, Order, Contact } from "./types";

export const TANZANIA_REGIONS = [
  "Arusha", "Dar es Salaam", "Dodoma", "Geita", "Iringa", "Kagera", "Katavi", 
  "Kigoma", "Kilimanjaro", "Lindi", "Manyara", "Mara", "Mbeya", "Morogoro", 
  "Mtwara", "Mwanza", "Njombe", "Pemba North", "Pemba South", "Pwani", "Rukwa", 
  "Ruvuma", "Shinyanga", "Simiyu", "Singida", "Songwe", "Tabora", "Tanga", 
  "Zanzibar North", "Zanzibar South", "Zanzibar West"
];

export const UGANDA_DISTRICTS = [
  "Kampala", "Wakiso", "Mukono", "Jinja", "Mbarara", "Gulu", "Arua", "Entebbe", "Mbale", "Masaka", "Lira", "Hoima", "Fort Portal"
];

export const KENYA_COUNTIES = [
  "Nairobi", "Mombasa", "Kisumu", "Nakuru", "Eldoret", "Machakos", "Kiambu", "Kilifi", "Uasin Gishu", "Kajiado"
];

export const INITIAL_USERS: User[] = [
  {
    id: 'admin-global-1',
    username: 'admin',
    password: 'admin@2025',
    fullName: 'Global Administrator',
    designation: 'CTO / System Root',
    role: 'Admin',
    status: 'active',
    allowedModules: Object.values(ERPModule),
    homeCountry: Country.TANZANIA,
    allowedCountries: Object.values(Country)
  },
  {
    id: 'mgr-uganda-1',
    username: 'pmanager',
    password: 'manage@2025',
    fullName: 'Operations Manager',
    designation: 'Head of Branch Ops',
    role: 'Director',
    status: 'active',
    allowedModules: [ERPModule.DASHBOARD, ERPModule.INFRASTRUCTURE, ERPModule.TASKS, ERPModule.ORDERS_PIPELINE, ERPModule.CRM, ERPModule.PORT_BIT_TRACKER, ERPModule.QUOTES],
    homeCountry: Country.UGANDA,
    allowedCountries: [Country.UGANDA, Country.TANZANIA]
  }
];

export const INITIAL_PROJECTS: Project[] = [
  {
    id: '1',
    name: 'Dar es Salaam BRT Phase 3',
    contractor: 'Sinohydro Corporation',
    region: 'Dar es Salaam',
    country: Country.TANZANIA,
    kilometers: 23.6,
    financer: 'World Bank',
    consultant: 'Ambicon Engineering',
    status: ProjectStatus.IN_PROGRESS,
    progress: 45,
    startDate: '2023-01-15',
    estimatedCompletion: '2025-06-30',
    bitumenSpecs: [
      { id: 'b1', grade: BitumenGrade.G_60_70, quantity: 1200 },
      { id: 'b2', grade: BitumenGrade.MC_30, quantity: 300 }
    ],
    updates: [],
    tasks: []
  },
  {
    id: '4',
    name: 'Kampala Expressway Extension',
    contractor: 'CCCC Uganda',
    region: 'Kampala',
    country: Country.UGANDA,
    kilometers: 15.0,
    financer: 'Govt of Uganda',
    consultant: 'Kocks Consult',
    status: ProjectStatus.PLANNING,
    progress: 10,
    startDate: '2024-05-01',
    estimatedCompletion: '2026-12-31',
    bitumenSpecs: [{ id: 'ug1', grade: BitumenGrade.G_60_70, quantity: 800 }],
    updates: [],
    tasks: []
  }
];

export const INITIAL_ORDERS: Order[] = [
  {
    id: 'ORD-2024-8842',
    orderDate: '2024-11-15',
    customerName: 'MegaBuild Contractors',
    supplier: 'ALKIN',
    shipper: 'SHIV/UGANDA',
    portOfDestination: 'DAR ES SALAAM',
    vesselPlanned: 'MV OCEAN STAR',
    company: Company.SHIV,
    items: [{ id: '1', name: 'Bitumen 60/70', quantity: 500, unitPrice: 420 }],
    financials: {
      totalAmount: 210000,
      currency: 'USD',
      amountPaid: 50000,
      balanceAmount: 160000,
      paymentStatus: PaymentStatus.PARTIAL,
      paymentHistory: [{ id: 'p1', date: '2024-11-16', amount: 50000, type: 'Advance', note: 'Initial Deposit' }]
    },
    currentStatus: OrderStatus.SHIPPED,
    timeline: [{ status: OrderStatus.SHIPPED, date: '2024-11-15', note: 'Order confirmed and sailed' }],
    documents: []
  }
];

export const INITIAL_CONTACTS: Contact[] = [
  {
    id: '1',
    companyName: 'TechFlow Systems Ltd',
    companyAddress: 'Industrial Area, Plot 45, Dar es Salaam',
    poBox: 'P.O. Box 12345',
    tin: '100-200-300',
    vrn: 'VRN-001',
    email: 'sarah.chen@techflow.io',
    contactPerson: 'Sarah Chen',
    phone: '+255 754 000 001',
    role: 'CTO',
    lastContacted: '2024-05-01',
    notes: 'Interested in AI automation.',
    avatarUrl: 'https://api.dicebear.com/7.x/avataaars/svg?seed=Sarah',
    sentiment: 'Positive',
    country: Country.TANZANIA
  }
];
